export default "__VITE_ASSET__DNXwnCce__"